var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"floating-label",class:{ 'float-above': _vm.floatAbove },style:({
    '--custom-top': _vm.customTop,
  }),attrs:{"for":_vm.forAttr}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }